import { ParamOrganizationSlug, ParamRegionUrl } from "./schema-DKEjeVqP.js";
import { defineTool } from "./define-SD6AQa4b.js";
import { apiServiceFromContext } from "./api-EaEPyKlQ.js";
import { structuredResult } from "./results-NF1RJbDZ.js";
import { z } from "zod";
import { setTag } from "@sentry/core";

//#region src/tools/catalog/create-team.ts
const createTeamOutputSchema = z.object({ team: z.object({
	id: z.string(),
	slug: z.string(),
	name: z.string()
}) });
var create_team_default = defineTool({
	name: "create_team",
	skills: ["project-management"],
	requiredScopes: ["team:write"],
	description: [
		"Create a new team in Sentry.",
		"",
		"USE THIS TOOL WHEN USERS WANT TO:",
		"- 'Create a new team'",
		"- 'Set up a team called [X]'",
		"- 'I need a team for my project'",
		"",
		"Be careful when using this tool!",
		"",
		"<examples>",
		"### Create a new team",
		"```",
		"create_team(organizationSlug='my-organization', name='the-goats')",
		"```",
		"</examples>",
		"",
		"<hints>",
		"- If any parameter is ambiguous, you should clarify with the user what they meant.",
		"</hints>"
	].join("\n"),
	inputSchema: {
		organizationSlug: ParamOrganizationSlug,
		regionUrl: ParamRegionUrl.nullable().default(null),
		name: z.string().trim().describe("The name of the team to create.")
	},
	annotations: {
		readOnlyHint: false,
		destructiveHint: false,
		openWorldHint: true
	},
	outputSchema: createTeamOutputSchema,
	async handler(params, context) {
		const apiService = apiServiceFromContext(context, { regionUrl: params.regionUrl ?? void 0 });
		const organizationSlug = params.organizationSlug;
		setTag("organization.slug", organizationSlug);
		const team = await apiService.createTeam({
			organizationSlug,
			name: params.name
		});
		return structuredResult({ team: {
			id: String(team.id),
			slug: team.slug,
			name: team.name
		} });
	}
});

//#endregion
export { createTeamOutputSchema, create_team_default };
//# sourceMappingURL=create-team-Bz1tSDLQ.js.map